import { connect } from 'react-redux';

import config from '@config';
import {
  setUXProp,
  hideDetailPanel,
  clearDetailPanel,
} from '@store/actions/ux';
import { getCookie } from '@themejs/helpers/cookies';
import { requestSearch } from '@search/store/actions/requests';
import { clearResults } from '@search/store/actions/results';
import Form from './form';

const locationHost = window.location.host;

if (locationHost.indexOf('freely') > -1) {
  config.defaultNID = config.searchDefaultNID;
}

const mapDispatchToProps = dispatch => ({
  search: query => {
    dispatch(
      setUXProp({
        searchQuery: query,
      }),
    );

    dispatch(hideDetailPanel());
    setTimeout(() => {
      dispatch(clearDetailPanel());
    }, config.detailPanelTransitionDuration);

    dispatch(clearResults());

    if (query.length > 0) {
      dispatch(
        requestSearch(
          query,
          getCookie(config.cookies.nidCookieName) || config.defaultNID,
        ),
      );
    }
  },
});

export default connect(null, mapDispatchToProps)(Form);
